var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarrierAppetite = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 10h-13M1.5 10l1.406-5.621A.5.5 0 0 1 3.39 4h9.218a.5.5 0 0 1 .485.379L14.5 10v2a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-2ZM4.5 6h1M7.5 6h1M10.5 6h1M4.5 8h1M7.5 8h1M10.5 8h1M4.5 4V2.5A.5.5 0 0 1 5 2h2.5a.5.5 0 0 1 .5.5V4",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarrierAppetite);
export default ForwardRef;